import {
    createContext,
    Dispatch,
    ReactNode,
    SetStateAction,
    useContext,
    useEffect,
    useRef,
    useState,
} from 'react'
import { Location } from 'entities/location'

export type JobForTrackingPixels = {
    location?: Pick<Location, 'country'>
}

const TrackingPixelsContext = createContext<{
    showApplicationTrackingPixels: boolean
    showRegistrationTrackingPixels: boolean
    setShowApplicationTrackingPixels: Dispatch<SetStateAction<boolean>>
    setShowRegistrationTrackingPixels: Dispatch<SetStateAction<boolean>>
} | null>(null)

export const WithTrackingPixels = ({ children }: { children: ReactNode }) => {
    const ref = useRef<boolean>(false)

    useEffect(() => {
        ref.current = true
    }, [])

    const [showApplicationTrackingPixels, setShowApplicationTrackingPixels] = useState(
        false,
    )
    const [showRegistrationTrackingPixels, setShowRegistrationTrackingPixels] = useState(
        false,
    )

    return (
        <TrackingPixelsContext.Provider
            value={{
                showApplicationTrackingPixels,
                setShowApplicationTrackingPixels,
                showRegistrationTrackingPixels,
                setShowRegistrationTrackingPixels,
            }}
        >
            {children}
        </TrackingPixelsContext.Provider>
    )
}

export const useTrackingPixels = () => {
    const context = useContext(TrackingPixelsContext)
    if (!context) {
        throw new Error(
            'useTrackingPixelsContext must be used within a TrackingPixelsContext',
        )
    }
    return context
}
